import useApi from "./useApi";
import productService from "../api/services/productService";

const useProducts = () => {
  //Api
  const { get,getbyobj, getById } = useApi();

  return {
    getAvailableProducts(params) {
      return getbyobj("/vendor/available-products", params);
    },
    getAllProduct(){
      return get("quik/product");
    },
    //Get products by id
    getProductsByid(id) {
      return getById("quik/product", id);
    },
    // Get vendor product detail by vendor_product_id
    getVendorProductDetailById(vendorProductId) {
      return getById("vendor/products", vendorProductId);
    },

    //Add product data
    addVendorProduct(payload) {
      return productService.addProduct(payload);
    },

    // Update vendor product (price, tax, availability)
    updateVendorProduct(vendorProductId, payload, userRole = "vendor") {
      return productService.updateVendorProduct(
        vendorProductId,
        payload,
        userRole
      );
    },
    // Get vendor product by vendor_product_id (new API)
    getVendorProductByVendorProductId(vendorProductId) {
      return productService.getVendorProductByVendorProductId(vendorProductId);
    },
  };
};

export default useProducts;
